import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { useAuth } from '../components/auth/AuthProvider';
import { CheckIcon, RocketIcon, CodeIcon, LayoutIcon, ZapIcon, PackageIcon } from 'lucide-react';
export const AboutPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const {
    isAuthenticated
  } = useAuth();
  const handleStartSelling = () => {
    if (isAuthenticated) {
      navigate('/sell-product');
    } else {
      navigate('/sell-with-us', {
        state: {
          openAuth: true
        }
      });
    }
  };
  const handleExploreProducts = () => {
    navigate('/browse');
  };
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-3038">
      <Navbar scrolled={scrolled} data-id="element-3039" />
      <main className="pt-24 pb-20" data-id="element-3040">
        <div className="container mx-auto px-4 md:px-6" data-id="element-3041">
          <div className="max-w-6xl mx-auto" data-id="element-3042">
            {/* Hero Section */}
            <div className="text-center mb-16" data-id="element-3043">
              <h1 className="text-3xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-transparent bg-clip-text" data-id="element-3044">
                About{' '}
                <span className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-transparent bg-clip-text" data-id="element-3045">
                  DG
                </span>
                <span className="bg-gradient-to-r from-[#2DB489] to-[#3DC79D] dark:from-[#4ED1A0] dark:to-[#6FDEBB] text-transparent bg-clip-text" data-id="element-3046">
                  Stack
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD] max-w-3xl mx-auto" data-id="element-3047">
                DGStack is a modern digital marketplace template designed to
                help you launch your own platform quickly and efficiently.
              </p>
            </div>
            {/* What is DGStack Section */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-12 shadow-sm mb-16" data-id="element-3048">
              <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-3049">
                What is DGStack?
              </h2>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg" data-id="element-3050">
                DGStack is not a finished SaaS product. It is a powerful starter
                template built for developers, creators, and entrepreneurs who
                want to launch a digital product marketplace.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] text-lg" data-id="element-3051">
                Instead of building everything from scratch, DGStack provides a
                complete foundation — including user authentication, dashboards,
                product listings, and a clean, scalable UI — so you can focus on
                your business, not the infrastructure.
              </p>
            </div>
            {/* Why DGStack Section */}
            <div className="mb-16" data-id="element-3052">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-3053">
                Why DGStack
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3054">
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3055">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3056">
                    <RocketIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3057" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3058">
                    Launch faster with a ready-to-use structure
                  </h3>
                </div>
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3059">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3060">
                    <LayoutIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3061" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3062">
                    Clean and modern UI designed for real-world use
                  </h3>
                </div>
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3063">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3064">
                    <CodeIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3065" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3066">
                    Built with scalable technologies (React, Firebase, Tailwind)
                  </h3>
                </div>
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3067">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3068">
                    <ZapIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3069" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3070">
                    Fully customizable to fit your brand and business model
                  </h3>
                </div>
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-3071">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-3072">
                    <PackageIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-3073" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-3074">
                    Supports multiple digital product types
                  </h3>
                </div>
              </div>
            </div>
            {/* What You Can Build Section */}
            <div className="mb-16" data-id="element-3075">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-3076">
                What You Can Build
              </h2>
              <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-12 shadow-sm" data-id="element-3077">
                <ul className="space-y-4 max-w-md mx-auto flex flex-col items-center" data-id="element-3078">
                  <li className="flex items-start" data-id="element-3079">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0] mr-3 flex-shrink-0" data-id="element-3080" />
                    <span className="text-lg text-gray-600 dark:text-[#B0C1BD]" data-id="element-3081">
                      Digital product marketplace
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-3082">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0] mr-3 flex-shrink-0" data-id="element-3083" />
                    <span className="text-lg text-gray-600 dark:text-[#B0C1BD]" data-id="element-3084">
                      Short-form video platform
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-3085">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0] mr-3 flex-shrink-0" data-id="element-3086" />
                    <span className="text-lg text-gray-600 dark:text-[#B0C1BD]" data-id="element-3087">
                      Template or asset store
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-3088">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0] mr-3 flex-shrink-0" data-id="element-3089" />
                    <span className="text-lg text-gray-600 dark:text-[#B0C1BD]" data-id="element-3090">
                      Niche creator marketplace
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-3091">
                    <CheckIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0] mr-3 flex-shrink-0" data-id="element-3092" />
                    <span className="text-lg text-gray-600 dark:text-[#B0C1BD]" data-id="element-3093">
                      Custom digital platform
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Built for Flexibility Section */}
            <div className="mb-16" data-id="element-3094">
              <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-12 shadow-sm" data-id="element-3095">
                <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-3096">
                  Built for Flexibility
                </h2>
                <p className="text-lg text-gray-600 dark:text-[#B0C1BD]" data-id="element-3097">
                  DGStack is designed to be flexible and developer-friendly. You
                  can modify layouts, add features, integrate payment systems,
                  and scale the platform as your business grows.
                </p>
              </div>
            </div>
            {/* CTA Section */}
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 text-white text-center" data-id="element-3098">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-3099">
                Start Building Your Marketplace
              </h2>
              <p className="text-lg opacity-90 mb-8 max-w-3xl mx-auto" data-id="element-3100">
                Launch faster, reduce development time, and focus on growing
                your platform.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-3101">
                <button onClick={handleStartSelling} className="bg-white text-[#0A3C52] px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-3102">
                  Start Selling
                </button>
                <button onClick={handleExploreProducts} className="bg-transparent border border-white text-white px-8 py-3 rounded-lg font-medium hover:bg-white/10 transition-colors" data-id="element-3103">
                  Explore Products
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-3104" />
    </div>;
};